import './Banner.css'

const Banner = () => {
    return(
        <header className='banner'>
            <img src="/imagens/banner.png"/>
        </header>    
    )
}

export default Banner
